import { render, staticRenderFns } from "./GlossStatusBadge.vue?vue&type=template&id=4e523879"
import script from "./GlossStatusBadge.vue?vue&type=script&lang=js"
export * from "./GlossStatusBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports